import { createQueryKeys } from '@lukemorales/query-key-factory';

import type {
  FetchEpisodesProgressArgs,
  FetchEpisodeProgressArgs,
  FetchEpisodeByIdArgs,
  FetchEpisodesArgs,
} from '../api/types/episodes.types';

import {
  fetchEpisodeStatistics,
  fetchEpisodesProgress,
  fetchEpisodeProgress,
  fetchEpisodeById,
  fetchEpisodes,
} from '../api/episodes.api';

export const episodesQueryKeys = createQueryKeys('episodes', {
  fetchEpisodeById: ({ id, locale, organizationId }: FetchEpisodeByIdArgs) => ({
    queryFn: () => fetchEpisodeById({ id, locale, organizationId }),
    // Episode is returned with all translations, so locale need not be in the key.
    queryKey: [organizationId, id],
  }),
  fetchEpisodeProgress: ({
    id,
    courseId,
    moduleId,
    organizationId,
  }: FetchEpisodeProgressArgs) => ({
    queryFn: () =>
      fetchEpisodeProgress({ id, courseId, moduleId, organizationId }),
    queryKey: [
      organizationId,
      id,
      'progress',
      moduleId ?? undefined,
      courseId ?? undefined,
    ],
  }),
  fetchEpisodeStatistics: ({
    id,
    locale,
    organizationId,
  }: FetchEpisodeByIdArgs) => ({
    queryFn: () => fetchEpisodeStatistics({ id, locale, organizationId }),
    queryKey: [organizationId, id, 'statistics', locale],
  }),
  fetchEpisodes: ({
    contentFilters,
    locale,
    organizationId,
    tableFilters,
  }: FetchEpisodesArgs) => ({
    queryFn: () =>
      fetchEpisodes({ contentFilters, locale, organizationId, tableFilters }),
    queryKey: [organizationId, contentFilters, tableFilters],
  }),
  fetchEpisodesProgress: ({
    items,
    organizationId,
  }: FetchEpisodesProgressArgs) => ({
    queryFn: () => fetchEpisodesProgress({ items, organizationId }),
    queryKey: [organizationId, 'progress', items],
  }),
  fetchInfiniteEpisodes: ({
    contentFilters,
    locale,
    organizationId,
    tableFilters,
  }: FetchEpisodesArgs) => ({
    queryFn: (context?: { pageParam?: unknown }) =>
      fetchEpisodes({
        contentFilters,
        locale,
        organizationId,
        tableFilters: {
          ...tableFilters,
          offset: (context?.pageParam as string) || '1',
        },
      }),
    queryKey: [organizationId, contentFilters, tableFilters],
  }),
});
